import { gql } from "@apollo/client";

export const processMedia = gql`
    mutation processMedia(
        $x: Int!
        $y: Int!
        $width: Int!
        $height: Int!
        $source: MediaSourceInput!
        $mediaType: String!
        $timestamp: Float
        $aspectRatio: AspectRatioType!
    ) {
        processMedia(
            input: {
                x: $x
                y: $y
                width: $width
                height: $height
                source: $source
                mediaType: $mediaType
                timestamp: $timestamp
                aspectRatioType: $aspectRatio
            }
        ) {
            mediaId
            mediaUrl
            mediaType
        }
    }
`;
